import log from 'salvo-lite/log'

class VideoContainer {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._video = this._elem.querySelector('[data-video]')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        log.debug(this.constructor.name, 'Initiating')

        this._elem.addEventListener('click', e => {
            e.preventDefault()

            if (this._video.paused) {
                this._video.play()
                this._elem.classList.add('video-is-playing')
                this._elem.classList.add('video-been-played')
            } else {
                this._video.pause()
                this._elem.classList.remove('video-is-playing')
            }
        })

        this._video.addEventListener('ended', e => {
            this._elem.classList.remove('video-is-playing')
            this._elem.classList.remove('video-been-played')
            this._video.load()
        })

        log.debug(this.constructor.name, 'Initiated')
    }
}

export default VideoContainer



// WEBPACK FOOTER //
// ./src/resources/scripts/components/VideoContainer.js